import FlakeId from 'flakeid'

const flake = new FlakeId()

export default flake
